/**
 *  
 * 功能：捕捉图片位置
 */



function getLineGuideStops(skipShape, stage) {
    // 获取stage的缩放比例和位移
    var scaleX = stage.scaleX();
    var scaleY = stage.scaleY();
    var stageX = stage.x();
    var stageY = stage.y();

    var vertical = [0, stage.width() / 2, stage.width()];
    var horizontal = [0, stage.height() / 2, stage.height()];

    // 扫描stage上的所有rectTransformer元素，考虑其缩放和位移
    stage.find(".rectTransformer").forEach((guideItem) => {
        if (guideItem === skipShape) {
            return;
        }

        var box = guideItem.getClientRect();

        // 根据stage的缩放和位移调整位置
        var adjustedBox = {
            x: (box.x - stageX) / scaleX,
            y: (box.y - stageY) / scaleY,
            width: box.width / scaleX,
            height: box.height / scaleY,
        };

        // 添加调整后的坐标到guides
        vertical.push([adjustedBox.x, adjustedBox.x + adjustedBox.width, adjustedBox.x + adjustedBox.width / 2]);
        horizontal.push([adjustedBox.y, adjustedBox.y + adjustedBox.height, adjustedBox.y + adjustedBox.height / 2]);
    });

    stage.find(".gridLh").forEach((guideItem) => {
        if (guideItem.attrs.reference && guideItem !== skipShape) {
            var box = guideItem.getClientRect();

            var adjustedBox = {
                x: (box.x - stageX) / scaleX,
                y: (box.y - stageY) / scaleY,
                width: box.width / scaleX,
                height: box.height / scaleY,
            };

            vertical.push([adjustedBox.x + adjustedBox.width / 2]);
            horizontal.push([adjustedBox.y + adjustedBox.height / 2]);
        }
    });

    stage.find(".gridLv").forEach((guideItem) => {
        if (guideItem.attrs.reference && guideItem !== skipShape) {
            var box = guideItem.getClientRect();

            var adjustedBox = {
                x: (box.x - stageX) / scaleX,
                y: (box.y - stageY) / scaleY,
                width: box.width / scaleX,
                height: box.height / scaleY,
            };

            vertical.push([adjustedBox.x + adjustedBox.width / 2]);
            horizontal.push([adjustedBox.y + adjustedBox.height / 2]);
        }
    });

    return {
        vertical: vertical.flat(),
        horizontal: horizontal.flat(),
    };
}

function getObjectSnappingEdges(node, stage) {
    var scaleX = stage.scaleX();
    var scaleY = stage.scaleY();
    var stageX = stage.x();
    var stageY = stage.y();

    var box = node.getClientRect();

    // 根据stage的缩放和位移调整位置
    var adjustedBox = {
        x: (box.x - stageX) / scaleX,
        y: (box.y - stageY) / scaleY,
        width: box.width / scaleX,
        height: box.height / scaleY,
    };

    return {
        vertical: [{
            guide: Math.round(adjustedBox.x),
            offset: Math.round(node.x() - adjustedBox.x),
            snap: "start",
        },
        {
            guide: Math.round(adjustedBox.x + adjustedBox.width / 2),
            offset: Math.round(node.x() - adjustedBox.x - adjustedBox.width / 2),
            snap: "center",
        },
        {
            guide: Math.round(adjustedBox.x + adjustedBox.width),
            offset: Math.round(node.x() - adjustedBox.x - adjustedBox.width),
            snap: "end",
        },
        ],
        horizontal: [{
            guide: Math.round(adjustedBox.y),
            offset: Math.round(node.y() - adjustedBox.y),
            snap: "start",
        },
        {
            guide: Math.round(adjustedBox.y + adjustedBox.height / 2),
            offset: Math.round(node.y() - adjustedBox.y - adjustedBox.height / 2),
            snap: "center",
        },
        {
            guide: Math.round(adjustedBox.y + adjustedBox.height),
            offset: Math.round(node.y() - adjustedBox.y - adjustedBox.height),
            snap: "end",
        },
        ],
    };
}

function getGuides(lineGuideStops, itemBounds) {
    var resultV = [];
    var resultH = [];

    lineGuideStops.vertical.forEach((lineGuide) => {
        itemBounds.vertical.forEach((itemBound) => {
            var diff = Math.abs(lineGuide - itemBound.guide);
            // if the distance between guild line and object snap point is close we can consider this for snapping
            if (diff < 5) {
                resultV.push({
                    lineGuide: lineGuide,
                    diff: diff,
                    snap: itemBound.snap,
                    offset: itemBound.offset,
                });
            }
        });
    });

    lineGuideStops.horizontal.forEach((lineGuide) => {
        itemBounds.horizontal.forEach((itemBound) => {
            var diff = Math.abs(lineGuide - itemBound.guide);
            if (diff < 5) {
                resultH.push({
                    lineGuide: lineGuide,
                    diff: diff,
                    snap: itemBound.snap,
                    offset: itemBound.offset,
                });
            }
        });
    });

    var guides = [];

    // find closest snap
    var minV = resultV.sort((a, b) => a.diff - b.diff)[0];
    var minH = resultH.sort((a, b) => a.diff - b.diff)[0];
    if (minV) {
        guides.push({
            lineGuide: minV.lineGuide,
            offset: minV.offset,
            orientation: "V",
            snap: minV.snap,
        });
    }
    if (minH) {
        guides.push({
            lineGuide: minH.lineGuide,
            offset: minH.offset,
            orientation: "H",
            snap: minH.snap,
        });
    }
    return guides;
};

function drawGuides(guides, layer) {
    guides.forEach((lg) => {
        if (lg.orientation === "H") {
            var line = new Konva.Line({
                points: [-6000, lg.lineGuide, 6000, lg.lineGuide],
                stroke: "rgb(255, 232, 41)",
                strokeWidth: 2.5,
                name: "guid-line",
                dash: [6, 6],
            });
            layer.add(line);
            layer.batchDraw();
        } else if (lg.orientation === "V") {
            var line = new Konva.Line({
                points: [lg.lineGuide, -5000, lg.lineGuide, 5000],
                stroke: "rgb(255, 232, 41)",
                strokeWidth: 2.5,
                name: "guid-line",
                dash: [6, 6],
            });
            layer.add(line);
            layer.batchDraw();
        }
    });
};


function dragmove(stage, layer) {
    stage.on("dragmove", (e) => {
        if (e.target.attrs.name !== "rectTransformer") {
            return;
        }
        // clear all previous lines on the screen
        layer.find(".guid-line").forEach((item) => {
            item.destroy();
        });

        // find possible snapping lines
        var lineGuideStops = getLineGuideStops(e.target, stage);
        // find snapping points of current object

        var itemBounds = getObjectSnappingEdges(e.target, stage);

        // now find where can we snap current object
        var guides = getGuides(lineGuideStops, itemBounds);

        // do nothing of no snapping
        if (!guides.length) {
            return;
        }
        drawGuides(guides, layer);

        guides.forEach((lg) => {
            switch (lg.snap) {
                case "start":
                    {
                        switch (lg.orientation) {
                            case "V":
                                {
                                    e.target.x(lg.lineGuide + lg.offset);
                                    break;
                                }
                            case "H":
                                {
                                    e.target.y(lg.lineGuide + lg.offset);
                                    break;
                                }
                        }
                        break;
                    }
                case "center":
                    {
                        switch (lg.orientation) {
                            case "V":
                                {
                                    e.target.x(lg.lineGuide + lg.offset);
                                    break;
                                }
                            case "H":
                                {
                                    e.target.y(lg.lineGuide + lg.offset);
                                    break;
                                }
                        }
                        break;
                    }
                case "end":
                    {
                        switch (lg.orientation) {
                            case "V":
                                {
                                    e.target.x(lg.lineGuide + lg.offset);
                                    break;
                                }
                            case "H":
                                {
                                    e.target.y(lg.lineGuide + lg.offset);
                                    break;
                                }
                        }
                        break;
                    }
            }
        });
    });
    stage.on("dragend", (e) => {
        // clear all previous lines on the screen
        layer.find(".guid-line").forEach((item) => {
            item.destroy();
        });
        
        layer.batchDraw();
    });
};


export {
    dragmove,
};